import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Marque } from '../../models/marque';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MarqueService {
    private apiUrl = `${environment.parameters_url}api/settings/marque`;
    constructor(private http: HttpClient) {}

    getMarquePerStation(idStation: number): Observable<Marque[]> {
        return this.http.get<any>(`${this.apiUrl}/${idStation}`).pipe(
            map(response => {
               // console.log('getMarquePerStation Response:', response);
                return response.marques || [];
            }),
            catchError(this.handleError)
        );
    }

    getAll(idStation: number, idUser: number): Observable<Marque[]> {
        return this.http.get<any>(`${this.apiUrl}/${idUser}/${idStation}`).pipe(
            map(response => {
               // console.log('getAll Response:', response);
                return response.marques || [];
            }),
            catchError(this.handleError)
        );
    }

    addMarque(marque: Marque): Observable<Marque> {
     //   console.log('addMarque Request:', marque);
        return this.http.post<any>(this.apiUrl, marque).pipe(
            map(response => {
               // console.log('addMarque Raw Response:', JSON.stringify(response, null, 2));
                const newMarque: Marque = response.marque || response;
               // console.log('addMarque Mapped Marque:', newMarque);
                if (!newMarque || !newMarque.libelle || !newMarque.id) {
               //     console.warn('Invalid marque response:', newMarque);
                    throw new Error('Invalid marque response');
                }
                return newMarque;
            }),
            catchError(error => {
                console.error('addMarque Error:', error);
                return this.handleError(error);
            })
        );
    }

    updateMarque(marque: Marque, idStation: number): Observable<Marque> {
      //  console.log('updateMarque Request:', marque);
        return this.http.put<any>(`${this.apiUrl}/${marque.id}`, { libelle: marque.libelle }).pipe(
            map(response => {
              //  console.log('updateMarque Raw Response:', JSON.stringify(response, null, 2));
                const updatedMarque: Marque = response.marque || response;
              //  console.log('updateMarque Mapped Marque:', updatedMarque);
                if (!updatedMarque || !updatedMarque.libelle || !updatedMarque.id) {
                    console.warn('Invalid updated marque response:', updatedMarque);
                    throw new Error('Invalid updated marque response');
                }
                return updatedMarque;
            }),
            catchError(error => {
                console.error('updateMarque Error:', error);
                return this.handleError(error);
            })
        );
    }

    private handleError(error: HttpErrorResponse): Observable<never> {
        let errorMessage = 'Une erreur est survenue lors de la communication avec le serveur.';
        if (error.error instanceof ErrorEvent) {
            errorMessage = `Erreur: ${error.error.message}`;
        } else {
            errorMessage = `Code d'erreur: ${error.status}\nMessage: ${error.message}`;
        }
        console.error('HandleError:', errorMessage);
        return throwError(() => new Error(errorMessage));
    }
}

